import Button from '../shared/ui/Button';
import StatusPage from '../shared/ui/feedback/StatusPage';

/**
 * Shown when the app's code could not be downloaded, typically a chunk that a
 * newer release replaced while this tab still ran the old index.html. Built on
 * StatusPage, which needs no router and no app module: only what the
 * bootstrap entry chunk already carries, and that chunk did load.
 */
export default function LoadError(): JSX.Element {
  return (
    <main>
      <StatusPage
        icon="alert"
        title="De applicatie kon niet laden"
        alert
        actions={
          <Button icon="refresh" onClick={() => window.location.reload()}>
            Ververs de pagina
          </Button>
        }
      >
        <p className="m-0">
          Ververs de pagina. Blijft dit gebeuren, controleer dan je verbinding.
        </p>
      </StatusPage>
    </main>
  );
}
